import client from './base';
import {
  LoginInput,
  LoginResponse,
  SendOtpInput,
} from '@shop/models/src/authentication';

export const login = async (m: LoginInput) =>
  client.base.post<LoginResponse>(`/v1/auth`, {
    body: JSON.stringify(m),
  });

export const sendOtp = async (body: SendOtpInput) =>
  client.base.post<LoginResponse>(`/v1/auth/otp/send`, {
    body: JSON.stringify(body),
  });
